import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const observers = new WeakMap()

const callback = ([{ target }]) => onMouseUp.listen(target)

const onMouseUp = object(listener, {
  type: mouseUp,
  once,
  passive,
  task: (
    textarea
  ) => {
    const { offsetWidth, offsetHeight } = textarea
    const postitContainer = textarea.closest('div.ea_auth__postit')

    if (postitContainer.hasAttribute('data-uid')) {
      const { dataset } = postitContainer
      const { uid } = dataset
      const url = href('auth/postit', {
        modify: 1,
        postit_size_x: offsetWidth,
        postit_size_y: offsetHeight,
        postit_uid: uid
      })

      globals.ea_link(url, 'nodiv_in', null)
    }
  }
})

const onBlur = object(listener, {
  type: blur,
  hooks: array([
    preventDefault
  ]),
  task: (
    textarea
  ) => {
    const postitContainer = textarea.closest('div.ea_auth__postit')
    if (postitContainer.hasAttribute('data-uid')) {
      const { dataset } = postitContainer
      const { uid } = dataset
      const url = href('auth/postit', {
        modify: 1,
        postit_text: textarea.value,
        postit_uid: uid
      })

      globals.ea_link(url, 'nodiv_in', null)
    }
  }
})

export default textarea => {
  const { ownerDocument } = textarea

  if (!observers.has(ownerDocument)) {
    const { defaultView } = ownerDocument
    const { ResizeObserver } = defaultView

    observers.set(ownerDocument, new ResizeObserver(callback))
  }

  observers.get(ownerDocument).observe(textarea)
  onBlur.listen(textarea)
}